<ul class="step-list" role="list" *ngIf="{ current: currentIndex$ | async, steps: steps$ | async } as ctx">
  <li
    *ngFor="let step of ctx.steps; let i = index; trackBy: trackByStateId"
    class="step-item"
    [class.step-item--active]="i === ctx.current"
    [class.step-item--completed]="step.status === 'COMPLETED'"
    [class.step-item--skipped]="step.status === 'SKIPPED'"
    [class.step-item--in-progress]="step.status === 'IN_PROGRESS' && i !== ctx.current"
    role="listitem"
    (click)="selectStep(i)"
    [attr.aria-current]="i === ctx.current ? 'step' : null">

    <!-- Step number / status indicator -->
    <div class="step-item__indicator">
      <ng-container *ngIf="step.status === 'COMPLETED'; else numOrActive">
        <mat-icon class="step-item__check-icon">check</mat-icon>
      </ng-container>
      <ng-template #numOrActive>
        <span class="step-item__number">{{ i + 1 }}</span>
      </ng-template>
    </div>

    <!-- Connector line (not on last item) -->
    <div
      class="step-item__connector"
      *ngIf="ctx.steps && i < ctx.steps.length - 1"
      [class.step-item__connector--done]="step.status === 'COMPLETED'">
    </div>

    <!-- Text content -->
    <div class="step-item__content">
      <span class="step-item__title">{{ step.itemTitle }}</span>
      <span class="step-item__sub" *ngIf="step.status === 'IN_PROGRESS'">In progress</span>
      <span class="step-item__sub step-item__sub--done" *ngIf="step.status === 'COMPLETED'">Completed</span>
      <span class="step-item__sub step-item__sub--skip" *ngIf="step.status === 'SKIPPED'">Skipped</span>
    </div>

    <!-- Active arrow -->
    <mat-icon class="step-item__arrow" *ngIf="i === ctx.current">chevron_right</mat-icon>

  </li>
</ul>
